import { array } from '@ember/helper';
import can from 'ember-can/helpers/can';
import cannot from 'ember-can/helpers/cannot';
import link from 'ember-link/helpers/link';
import RouteTemplate from 'ember-route-template';
import QuestionnaireForm from 'garaje/components/visitors/questionnaires/form';

import type { GlobalOverviewQuestionnairesShowRouteModel } from './route';

interface Signature {
  Args: {
    model: GlobalOverviewQuestionnairesShowRouteModel;
  };
}

export default RouteTemplate<Signature>(
  <template>
    {{#let (link route="location-overview.questionnaires") as |indexRouteLink|}}
      <QuestionnaireForm
        @availableLocales={{(array)}}
        @backLink={{indexRouteLink}}
        @canDeleteQuestionnaires={{can "delete global questionnaires"}}
        @changedModels={{@model.changes}}
        @defaultLocale="en"
        @fetchFlowsPage={{@model.fetchFlowsPage}}
        @flows={{@model.flows}}
        @questionnaire={{@model.questionnaire}}
        @onSave={{indexRouteLink.transitionTo}}
        @readOnly={{cannot "update global questionnaires"}}
      />
    {{/let}}
  </template>,
);
